import { render, staticRenderFns } from "./artifacts_bulk_delete.vue?vue&type=template&id=46ef4e1f"
import script from "./artifacts_bulk_delete.vue?vue&type=script&lang=js"
export * from "./artifacts_bulk_delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports